import "../../../css/DesignSystem/Inputs/ToggleButton.css";

const ToggleButton = ({ checked, onChange, disabled = false }) => {
  return (
    <button
      type="button"
      className={`toggle-button ${checked ? "toggle-button--active" : ""}`}
      onClick={() => !disabled && onChange(!checked)}
      disabled={disabled}
      aria-pressed={checked}
    >
      <span />
    </button>
  );
};

export default ToggleButton;
